// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__1IMOS","inner":"checkbox_inner__nMVSI","checked":"checkbox_checked__1j9Fy","unchecked":"checkbox_unchecked__1EnNz","text":"checkbox_text__2weft"};